import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { Checkbox } from "@mbo/forms";
import { Loader } from "@mbo/icons";

import { StyledWrapper } from "./table.style";

const TableLayout = ({ columns, compact, data, download, isLoading, mode }) => {
  const [downloadParams, setDownloadParams] = useState([]);

  useEffect(() => {
    setDownloadParams([]);
  }, [data]);

  const changeHandler = (e) => {
    const params = [...downloadParams];
    let param = "";

    if (e.target.dataset.name != undefined) {
      param = `${e.target.dataset.name}[]=${e.target.name}`;
    } else {
      param = `${e.target.name}=true`;
    }

    if (e.target.checked) {
      if (!params.includes(param)) {
        params.push(param);
        setDownloadParams(params);
      }
    } else {
      if (params.includes(param)) {
        params.splice(params.indexOf(param), 1);
        setDownloadParams(params);
      }
    }
  };

  return (
    <StyledWrapper>
      <table className={compact ? "compact" : undefined}>
        <thead>
          <tr>
            {columns?.map(
              (column, colIndex) =>
                column.label && (
                  <th colSpan={column.span} key={colIndex}>
                    {column.label}
                  </th>
                ),
            )}
            {download && mode == download?.mode && download?.url && (
              <th className="download">
                <a
                  href={`${download?.url}?${downloadParams.join("&")}`}
                  className={downloadParams.length ? undefined : "disabled"}
                  title="Export"
                  target="_blank"
                  download
                  rel="noreferrer"
                >
                  Export
                </a>
              </th>
            )}
          </tr>
        </thead>
        <tbody className={data ? undefined : "empty"}>
          {data && download && mode == download?.mode && download?.options && (
            <tr className="download">
              <td colSpan={columns.length}>
                <div className="download-options">
                  {download.options.map((option, optionIndex) => (
                    <div className="download-option" key={optionIndex}>
                      {option?.type == "checkbox" && (
                        <Checkbox
                          checkboxValue={option.name}
                          title={option.label}
                          onChange={changeHandler}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns?.map((column, colIndex) => (
                <td width={column.width} key={colIndex}>
                  {column.type == "link" && (
                    <div>
                      {row[column.path] ? (
                        <>
                          <a href={row[column.path]} target="_blank" rel="noreferrer">
                            {row[column.field] || "\u00A0"}
                          </a>
                          {column.dashboard && row[column.dashboard] && (
                            <>
                              <br />
                              <a href={row[column.dashboard]} target="_blank" rel="noreferrer">
                                (dashboard)
                              </a>
                            </>
                          )}
                        </>
                      ) : (
                        row[column.field] || "\u00A0"
                      )}
                    </div>
                  )}
                  {column.type == "actions" && (
                    <div className="actions-group">
                      {column.actions.map(
                        (action, actionIndex) =>
                          row[action.path] && (
                            <Link
                              to={row[action.path]}
                              title={action.title}
                              key={actionIndex}
                            >
                              {action.label}
                              {action.icon && <img src={action.icon} alt="" />}
                            </Link>
                          ),
                      )}
                    </div>
                  )}
                  {column.type == "text" &&
                    (colIndex == 0 &&
                    download &&
                    download?.select &&
                    mode == download?.mode ? (
                      <Checkbox
                        checkboxValue={row[column.field]}
                        title={row[column.field]}
                        data-name={download.select?.name}
                        onChange={changeHandler}
                      />
                    ) : (
                      <div>{row[column.field] || "\u00A0"}</div>
                    ))}
                </td>
              ))}
            </tr>
          ))}
          <tr className={`loading-overlay ${isLoading ? "" : "hidden"}`}>
            <td>
              <Loader />
            </td>
          </tr>
        </tbody>
      </table>
    </StyledWrapper>
  );
};

export default TableLayout;
